import classNames from 'classnames';
import styles from './styles/styles.module.scss';

type Props = {
  className?: string;
};

const InfoDividerDot = ({ className }: Props) => <span className={classNames(styles.dot, className)}>·</span>;

export default InfoDividerDot;
